import React from 'react';
import {
  Box,
  Divider,
  FloatingNotification,
  FormField,
  Input,
  Radio,
  RadioGroup,
} from '@wix/design-system';
import { NamespaceType } from '@wix/ambassador-devcenter-apps-v1-app/types';
import type { NamespacePrefixes } from '../../useBlocksNamespaceModalState';
import { DataHooks } from '../../../../../../constants/dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';

export const NamespaceSection = ({
  showAdvanced,
  namespace,
  setNamespace,
  selectedPrefixType,
  setSelectedPrefixType,
  availablePrefixes,
  isValidating,
  error,
}: NamespaceSectionProps) => {
  const { t } = useTranslation();

  if (!showAdvanced) {
    return null;
  }

  return (
    <Box direction="vertical">
      {availablePrefixes.COMPANY ? (
        <>
          <Box marginTop="SP4" marginBottom="SP4" display="block">
            <Divider />
          </Box>
          <FormField
            label={t('app.template.page.blocks.namespace.modal.label.prefix')}
            labelPlacement="top"
            stretchContent={false}
          >
            <RadioGroup
              display="horizontal"
              value={selectedPrefixType}
              onChange={setSelectedPrefixType}
            >
              <Radio value={NamespaceType.COMPANY}>
                {t('app.template.page.blocks.namespace.modal.label.company')}
              </Radio>
              <Radio value={NamespaceType.ACCOUNT}>
                {t('app.template.page.blocks.namespace.modal.label.account')}
              </Radio>
            </RadioGroup>
          </FormField>
        </>
      ) : null}
      <Box marginTop="SP4" display="block">
        <FormField
          label={t('app.template.page.blocks.namespace.modal.label.preview')}
        >
          <Input
            dataHook={DataHooks.BlocksModalNamespaceInput}
            value={namespace}
            size="large"
            onChange={(e) => setNamespace(e.target.value)}
            prefix={
              <Input.Affix>
                {availablePrefixes?.[selectedPrefixType]}/
              </Input.Affix>
            }
            status={isValidating ? 'loading' : error ? 'error' : undefined}
            statusMessage={t(error)}
          />
        </FormField>
      </Box>
      <Box marginTop="SP4">
        <FloatingNotification
          type="standard"
          showCloseButton={false}
          width="100%"
          text={t('app.template.page.blocks.namespace.modal.label.note')}
        />
      </Box>
    </Box>
  );
};

export type NamespaceSectionProps = {
  showAdvanced: boolean;
  namespace: string;
  setNamespace: (namespace: string) => void;
  selectedPrefixType: NamespaceType;
  setSelectedPrefixType: (prefix: NamespaceType) => void;
  availablePrefixes: NamespacePrefixes;
  isValidating: boolean;
  error?: string;
};
